module.exports = __webpack_public_path__ + "static/media/undraw_progressive_app_m9ms_grey.8c332598.svg";